export const PRIORITY_COLORS = {
    1: 'cccccc',
    2: 'b6b6b7',
    3: 'a1a1a3',
    4: '8c8c8f',
    5: '78787b',
    6: 'f5bc35',
    7: 'f4a235',
    8: 'f18835',
    9: 'ec5f34',
    10: 'e94a33',
    50: 'e94a33',
    100: 'e94a33'
}